import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {FormModule} from './FormModule'
import {TableRoomsFromRoomWrapper} from '../Tables/TableRooms'
import {TableFurnitureFromRoomWrapper} from '../Tables/TableFurnitures'
import {TableBathRoomsFromRoomWrapper} from '../Tables/TableBathRooms'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {OccupancyLayout} from '../Layout/OccupancyLayout'

const FormEditModuleWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
            {isAllowed('HABITACION/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Habitaciones</Tab>
            )}
            {isAllowed('MOBILIARIO/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Mobiliario</Tab>
            )}
            {isAllowed('BANOS/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>Baños</Tab>}
            {isAllowed('LAYOUT/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>Layout</Tab>}
          </TabList>
          <TabPanel>
            <FormModule />
          </TabPanel>
          {isAllowed('HABITACION/ACCESO') && (
            <TabPanel>
              <TableRoomsFromRoomWrapper />
            </TabPanel>
          )}
          {isAllowed('MOBILIARIO/ACCESO') && (
            <TabPanel>
              <TableFurnitureFromRoomWrapper />
            </TabPanel>
          )}
          {isAllowed('BANOS/ACCESO') && (
            <TabPanel>
              <TableBathRoomsFromRoomWrapper />
            </TabPanel>
          )}
          {isAllowed('LAYOUT/ACCESO') && (
            <TabPanel>
              <OccupancyLayout />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export {FormEditModuleWrapper}
